import 'pannellum/build/pannellum';

/**
 * Panorama image class using the Pannellum library
 * Documentation here: https://pannellum.org/documentation/reference/
 */
class Pano {
  constructor(panoEl) {
    this.el = panoEl;
    this.url = this.el.getAttribute('panolink');
    this.title = this.el.getAttribute('panotitle');
    this.autoLoad = this.el.hasAttribute('panoautoload');
    this.showCompass = this.el.hasAttribute('panoShowCompass');
    this.panoSettings = {
      type: 'equirectangular',
      panorama: this.url,
      title: this.title,
      compass: this.showCompass,
      autoLoad: this.autoLoad,
    };

    // If the Pannellum library doesn't exist, show error, otherwise init the pano

    // eslint-disable-next-line no-undef
    if (!pannellum) {
      console.error('TOUJOU: Could not initialize the panorama image');
    } else {
      this.initPano();
    }
  }

  // Initialize the pano element
  initPano() {
    // eslint-disable-next-line no-undef
    pannellum.viewer(this.el, this.panoSettings);
  }
}

function initPanoSlider(panoSlider) {
  const panoSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    scrollLock: true,
    resizeLock: true,
    rewind: true,
  };
  // eslint-disable-next-line no-undef
  const slider = new Glider(panoSlider, panoSliderOptions);

  slider.setOption({
    arrows: {
      prev: panoSlider.parentElement.querySelector('.slider__control--prev'),
      next: panoSlider.parentElement.querySelector('.slider__control--next'),
    },
    dots: panoSlider.parentElement.querySelector('.slider__pagination'),
  });
  slider.refresh(true);
}

/**
 * Wait for the page to load and initialize all the d1i panomara elements
 */
document.addEventListener('DOMContentLoaded', () => {
  const panos = document.querySelectorAll('.d1i-panoramas__panorama');
  if (!panos) return;

  panos.forEach((pano) => {
    pano._pano = new Pano(pano);
  });

  const panoSliders = document.querySelectorAll('.d1i-panoramas__slider .d1i-panoramas__slider-track');
  if (!panoSliders) return;

  panoSliders.forEach((panoSlider) => {
    initPanoSlider(panoSlider);
  });
});
